export default __webpack_public_path__ + "static/media/xponetiq.924efa2d.png";